import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/DescriptionList/DescriptionList.tsx
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var DescriptionList = _a => {
  var _b = _a,
    {
      children,
      className
    } = _b,
    rest = __objRest(_b, ["children", "className"]);
  if (!children) {
    return null;
  }
  return /* @__PURE__ */jsx("dl", __spreadProps(__spreadValues({}, rest), {
    className: clsx("pd:descriptionlist", className),
    children
  }));
};
var DescriptionList_default = DescriptionList;
export { DescriptionList_default };